import {PortalModule} from "@/services/store/modules/portals/PortalModule";
import {getSponsorPortal} from "@/lib/Portal";

export class SponsorModule extends PortalModule {
    public portal = getSponsorPortal();
}
